export const AGGREGATOR_ORDER_META = Object.freeze({
  yango: Object.freeze({
    code: "yango",
    label: "Yango",
    backgroundColor: "#ff0000",
    textColor: "#ffffff",
    icon: "/icons/yango-icon.png",
    logo: "/icons/yango.png",
    priceField: "yango_price",
  }),
  glovo: Object.freeze({
    code: "glovo",
    label: "Glovo",
    backgroundColor: "#ffcd1b",
    textColor: "#00a082",
    icon: "/icons/glovo-icon.png",
    logo: "/icons/glovo-moo-sync.png",
    priceField: "glovo_price",
  }),
});

export const normalizeAggregatorCode = (value) => {
  const normalized = String(value || "").trim().toLowerCase();
  if (!normalized) return null;
  if (normalized.includes("yango")) return "yango";
  if (normalized.includes("glovo")) return "glovo";
  return null;
};

const resolveAggregatorFromOrderNumber = (value) => {
  const normalized = String(value || "").trim().toUpperCase();
  if (/(^|-)YG(-|$)/.test(normalized)) return "yango";
  if (/(^|-)GL(-|$)/.test(normalized)) return "glovo";
  return null;
};

export const resolveOrderAggregator = (order = {}) => {
  const code =
    normalizeAggregatorCode(order.deliveryMethod ?? order.delivery_method) ||
    normalizeAggregatorCode(order.activeAggregator) ||
    normalizeAggregatorCode(order.deliveryMode ?? order.delivery_mode) ||
    resolveAggregatorFromOrderNumber(order.orderNumber ?? order.order_number);
  return code ? AGGREGATOR_ORDER_META[code] : null;
};

export const isStandaloneAggregatorPayment = (order = {}) =>
  Boolean(normalizeAggregatorCode(order.activeAggregator));

export const buildAggregatorNewOrderAnnouncement = (
  payload = {},
  { announceServerName = true } = {},
) => {
  const aggregator = resolveOrderAggregator(payload);
  if (!aggregator) return null;
  const firstName = String(payload.serverName || "").trim().split(/\s+/)[0] || "";
  return announceServerName && firstName
    ? `${firstName} a envoyé une commande ${aggregator.label}`
    : `Nouvelle commande ${aggregator.label} reçue`;
};

export const buildAggregatorDelayAnnouncement = (payload = {}) => {
  const aggregator = resolveOrderAggregator(payload);
  return aggregator
    ? `Rappel retard. La commande ${aggregator.label} n'est pas encore acceptée.`
    : null;
};
